// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"621cfc53","121":"26bbfa89","558":"621cfc53","642":"38771e00","989":"621cfc53"}[chunkId] + ".chunk.css";
};